import React from 'react';
import PropTypes from 'prop-types';
import { memoize } from 'underscore';
import { ReactObservable } from '@bingads-webui-react/react-observable';
import { CallObservable } from '@bingads-webui-universal/observable';

const convertPromiseToObservable = memoize(
  promise => new CallObservable({
    fetch: promise,
  }),
  // The promiseHashFn is used to generate a unique key for the memoization
  // The promise.toString() is used as the default key, which cannot reflect the params
  (promise, promiseHashFn) => (promiseHashFn ? promiseHashFn() : promise.toString())
);

function ReactObservablePromiseImpl({
  promise,
  promiseHashFn,
  fallback,
  onError,
  children,
}) {
  const observable = convertPromiseToObservable(promise, promiseHashFn);

  return (
    <ReactObservable
      observable={observable}
      fallback={fallback}
      onError={onError}
    >
      {children}
    </ReactObservable>
  );
}

ReactObservablePromiseImpl.propTypes = {
  promise: PropTypes.func.isRequired,
  promiseHashFn: PropTypes.func,
  fallback: PropTypes.element.isRequired,
  onError: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
};

ReactObservablePromiseImpl.defaultProps = {
  promiseHashFn: undefined,
};

export const ReactObservablePromise = ReactObservablePromiseImpl;
